import { render, staticRenderFns } from "./SidebarComponent.vue?vue&type=template&id=405d6ee5&scoped=true"
import script from "./SidebarComponent.vue?vue&type=script&lang=js"
export * from "./SidebarComponent.vue?vue&type=script&lang=js"
import style0 from "./SidebarComponent.vue?vue&type=style&index=0&id=405d6ee5&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405d6ee5",
  null
  
)

export default component.exports